<template>
    <NuxtLoadingIndicator />
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
    <div class="w-full h-full fixed top-0 left-0 bg-white opacity-75 z-[9999999] loading_dialog" style="display: none;">
        <div class="flex justify-center items-center mt-[50vh]">
            <div class="m-auto">
                <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="8"
                    class="fill-surface-0 dark:fill-surface-800" animationDuration=".5s"
                    aria-label="Custom ProgressSpinner" />
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/layouts/AppEventBus';

export default {
    mounted() {
        EventBus.on('dark-mode-toggle', this.darkModeToggleListener);
    },
    beforeUnmount() {
        EventBus.off('dark-mode-toggle', this.darkModeToggleListener);
    },
    methods: {
        darkModeToggleListener(event) {
            if (!document.startViewTransition) {
                this.toggleDarkMode(event);

                return;
            }

            document.startViewTransition(() => this.toggleDarkMode(event));
        },
        toggleDarkMode() {
            document.documentElement.classList.toggle('p-dark');
            this.$appState.darkTheme = !this.$appState.darkTheme;

            EventBus.emit('dark-mode-toggle-complete');
        }
    }
};
</script>
